import { useMutation } from '@tanstack/react-query';
import type { CalculatorPreviewDto, CalculatorPreviewInput } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';

interface CalculatorPreviewApiResponse {
  success: boolean;
  data: CalculatorPreviewDto;
}

/**
 * Mutation hook for the live calculator preview panel.
 * Calls POST /calculators/preview — runs the full calculator without writing to the DB.
 * The consuming component should debounce calls to mutate() by 300ms (per MILESTONES.md M-8).
 */
export function useCalculatorPreview() {
  return useMutation({
    mutationFn: async (input: CalculatorPreviewInput) => {
      const response = await apiClient.post<CalculatorPreviewApiResponse>(
        '/calculators/preview',
        input,
      );
      return response.data.data;
    },
  });
}
